import { render, staticRenderFns } from "./social-button.vue?vue&type=template&id=8024b7fc&scoped=true&"
import script from "./social-button.vue?vue&type=script&lang=js&"
export * from "./social-button.vue?vue&type=script&lang=js&"
import style0 from "./social-button.vue?vue&type=style&index=0&id=8024b7fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8024b7fc",
  null
  
)

export default component.exports